import EnumsManager from 'utils/EnumsManager';
import { NEW_EMAIL_UPDATE_SELECTED_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE_CONTENT,
  NEW_EMAIL_UPDATE_SELECTED_TEMPLATE_RESET,
  NEW_EMAIL_TEMPLATES_PAGENATIONS, NEW_EMAIL_SET_TEMPLATES,
  NEW_EMAIL_RESET_TEMPLATES
} from './actionType';

const initialState = {
  selectedEmailTemplate: {},
  newEmailTemplates: []
};

const selectedEmailTemplate = (
  state = initialState.selectedEmailTemplate,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case NEW_EMAIL_UPDATE_SELECTED_TEMPLATE:
      return payload;
    case UPDATE_EMAIL_TEMPLATE_CONTENT:
      const { content } = payload;
      return {
        ...state,
        content
      };
    case NEW_EMAIL_UPDATE_SELECTED_TEMPLATE_RESET:
      return initialState.selectedEmailTemplate;
    default:
      return state;
  }
};
const newEmailTemplatesDataTablePagination = (
  state = {
    perPage: EnumsManager.DefaultPageConfigs.PageSize,
    currentPage: 1,
    total: 0
  },
  action
) => {
  switch (action.type) {
    case NEW_EMAIL_TEMPLATES_PAGENATIONS:
      return {
        perPage: action.perPage,
        currentPage: action.currentPage,
        total: action.total
      };
    default:
      return state;
  }
};

const newEmailTemplates = (
  state = initialState.newEmailTemplates,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case NEW_EMAIL_SET_TEMPLATES:
      return payload;
    case NEW_EMAIL_RESET_TEMPLATES:
      return initialState.newEmailTemplates;
    default:
      return state;
  }
};

export {
  selectedEmailTemplate,
  newEmailTemplatesDataTablePagination,
  newEmailTemplates
};




// WEBPACK FOOTER //
// ./src/views/email/newEmail/flow/reducer.js